export default function MobileBottomSpacer() {
  return <div className="h-12 md:h-auto"></div>;
}
